import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { isLeavingForSignIn } from '../services/api';
//import { useUser } from '../context/UserContext';
// While a 401 is already loading the sign-in page (services/api.js), render nothing rather than show the sign-in page here
// first, which would use up its once-only notice (S-6.1 pt 5.2, PR #8).
const PrivateRoute = () => {
    const isAuthenticated = localStorage.getItem('isAuthenticated');
    const location = useLocation();
    if (!isAuthenticated && isLeavingForSignIn()) return null;
    return isAuthenticated 
        ? <Outlet /> 
        : <Navigate to="/login" state={{ from: location }} replace />;
};
export default PrivateRoute;